import type { GetMyFeatureFlagsResult } from "api-contracts/rpc/feature-flags";
import { resolve } from "ui-common/di";
import type { IAuthState } from "ui-common/services/auth/types";
import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const featureFlagsQueryOptions = queryOptions({
  queryKey: ["feature-flags"],
  queryFn: async (): Promise<GetMyFeatureFlagsResult> => {
    const authState = resolve<IAuthState>("authState");
    await authState.ready;

    if (!authState.isAuthenticated.get()) return { features: [] };
    return rpc("get-my-feature-flags", {});
  },
});
